module.exports = _.merge;


//////////////////
// WEBPACK FOOTER
// external "_.merge"
// module id = 165
// module chunks = 0